import Swiper from 'swiper'
import { A11y, FreeMode, Navigation } from 'swiper/modules'

export const selector = '.carousel-swiper'

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('Carousel Swiper')

    let isPrevBtnDisabled = false

    const isLoopOn = el
        .hasAttribute('data-carousel-loop')

    const isManualScroll = el
        .hasAttribute('data-carousel-manualscroll')

    const carouselSwiper = new Swiper(el, {
        modules: [A11y, FreeMode, Navigation],
        slidesPerView: 'auto',
        lazyPreloadPrevNext: 1,
        freeMode: {
            enabled: true,
            sticky: false
        },
        cssMode: isManualScroll,
        breakpoints: {
            1100: {
                freeMode: isManualScroll,
                loop: isLoopOn,
                loopAdditionalSlides: 1,
                speed: 1200
            }
        },
        navigation: {
            nextEl: '.carousel-swiper-button-next',
            prevEl: '.carousel-swiper-button-prev'
        }
    })

    const disablePrevBtn = (disabled) => {
        const prevBtn = carouselSwiper.navigation.prevEl

        if (!prevBtn)
            return

        carouselSwiper.allowSlidePrev = !disabled
        prevBtn.disabled = disabled
        prevBtn.setAttribute('tabindex', disabled
            ? -1
            : 0)

        isPrevBtnDisabled = disabled
    }

    if (isLoopOn & window.innerWidth >= 992) {
        disablePrevBtn(true)

        carouselSwiper
            .on('slideNextTransitionStart', () => {
                if (isPrevBtnDisabled)
                    disablePrevBtn(false)
            })
    }

    // Log instance
    console.log(carouselSwiper)

    console.groupEnd()

    return carouselSwiper
}
